import React from 'react';

const ProvidersNew = () => {
    return ( <h1>ProvidersNew</h1> );
}
 
export default ProvidersNew;
